import {AnalyticsEventActions} from '@mintdata-wsp/common/controllers/analytics/AnalyticsEventActions';
import {commonControllers} from '@mintdata-wsp/common/controllers/CommonControllers';
import {rootState} from '@mintdata-wsp/common/state/RootState';
import {controllers} from '@mintdata-wsp/wsp/controllers/WspControllers';
import {PageLoader} from '@mintdata-wsp/wsp/ui/components/pageLoader/PageLoader';
import {paths} from '@mintdata-wsp/wsp/ui/routes/Routing';
import {FlowEditor} from '@mintdata-wsp/wsp/ui/views/visualDesigner/flow/FlowEditor';
import {LocalStateUtil} from '@mintdata-wsp/wsp/util/LocalStateUtil';
import {SpinnerSize, SpinnerStyle} from '@mintdata/mint-kit/impl/components/spinner/Spinner';
import * as classnames from 'classnames/bind';
import * as is from 'is_js';
import {action, observable} from 'mobx';
import {observer} from 'mobx-react';
import * as React from 'react';
import {RouteComponentProps} from 'react-router';

const styles = require('./FlowEditorPage.less');
const cx = classnames.bind(styles);

@observer
export class FlowEditorPage extends React.Component<RouteComponentProps<any>, any>
{
    @observable isLoading:boolean = true;
    @observable isLeaving:boolean = false;

    public constructor(props:RouteComponentProps<any>)
    {
        super(props);

        if( is.not.desktop() )
        {
            controllers.navigation.navigateTo(paths.designs(), {match: this.props.match});
            return;
        }

        this._init(props);
    }

    public componentWillReceiveProps(nextProps:RouteComponentProps<any>)
    {
        const {projectId, designId, functionId} = this.props.match.params;

        const {
            projectId: nextProjectId,
            designId: nextDesignId,
            functionId: nextFunctionId
        } = nextProps.match.params;

        if( projectId !== nextProjectId ||
            designId !== nextDesignId ||
            functionId !== nextFunctionId )
        {
            this._init(nextProps);
        }
    }

    public componentWillUnmount()
    {
        //  Performing necessary cleanup
        const {flow} = controllers.ui;
        flow.performFlowEditorCleanup();
    }

    @action
    private _stopLoading():void
    {
        this.isLoading = false;
    }

    private _getUrlParams(props:RouteComponentProps<any>):{projectId:number, designId:number, functionId:number}
    {
        const {projectId, designId, functionId} = props.match.params;

        return {
            projectId: Number(projectId),
            designId: Number(designId),
            functionId: Number(functionId)
        };
    }

    private async _init(props:RouteComponentProps<any>):Promise<void>
    {
        const {artifacts, flow, flowComponentsPanel, openDesign, multiplayer} = controllers.ui;
        const {projectId, designId, functionId} = this._getUrlParams(props);
        const {username} = rootState.userSession.currentUser;

        controllers.navigation.setCurrentRouteProps(props);

        await artifacts.ensureCloudArtifactsAreLoaded();

        flowComponentsPanel.onCloudArtifactsLoaded();

        await flow.ensureFlowsAreLoaded(projectId, designId);

        flow.openFlow(functionId);

        if( !openDesign.getOpenDesign() )
        {
            const isMultiplayerMode = location.hash.indexOf('multiplayer=no') === -1;
            const isMultiplayerBustCache = location.hash.indexOf('bust-cache=1') > -1;

            if( isMultiplayerMode )
            {
                const userId = await controllers.user.syncUserId();
                await multiplayer.connect(projectId, designId, userId, isMultiplayerBustCache);
            }

            await openDesign.openDesign(projectId, designId, isMultiplayerMode);

            // When design is being opened, it's project becomes last used project.
            const orgSid = rootState.userSession.currentOrganization.siteId;
            LocalStateUtil.storeSelectedProject(projectId, orgSid);

            artifacts.startLoadingBundlesForVisualArtifacts();
        }

        this._stopLoading();
        controllers.ui.anyPage.disablePageLoader();

        commonControllers.analytics.main.initAllVendors();
        controllers.analytics.main.trackEvent(AnalyticsEventActions.WSP_PAGE_LOADED);
    }

    public render():JSX.Element
    {
        const globalPageLoader = rootState.ui.anyPage.isLoading;
        const thisPageLoader = this.isLoading || this.isLeaving || controllers.ui.flow.isNewFlowCreating();
        const isShowPageLoader = !globalPageLoader && thisPageLoader;

        return (
            <div>
                <FlowEditor />
                {
                    isShowPageLoader &&
                    <PageLoader spinnerProps={{size: SpinnerSize.Large_64, style: SpinnerStyle.White}} />
                }
            </div>
        );
    }
}
